<template>
  <div class="country-select">
    <div class="country-list-view" v-if="$globals.isMobile">

      <h3>
        <a href="#" :class="{ active: isActive }" @click="toggleList">
          <img src="../assets/triangle.svg"/>Land auswählen
        </a>
      </h3>

      <transition name="slide" mode="out-in">
        <div class="country-list" v-show="isActive">
          <a href="" class="country"
            @click="onListClick(country, $event)"
            v-for="country in getCountries()"
            v-bind:key="country.Id"
            :class="[country.activeClass, { active: country.active }]">{{ country.Land }}</a>
        </div>
      </transition>

    </div>

    <WorldMap
    v-if="!$globals.isMobile"
    :countries="countries"
    :selectedCountries="selectedCountries"
    :colors="colors"
    @setCountry="onListClick" />

  </div>
</template>

<script>
import WorldMap from '@/components/WorldMap.vue';

export default {
  name: 'countryselect',
  components: {
    WorldMap,
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    onListClick(country, $e) {
      if ($e) $e.preventDefault();
      this.$store.dispatch('SET_COUNTRY', country)
      if (country) this.$emit('setCountry', country);
    },
    getCountries() {
      _.forEach(this.countries, (c, i) => {
        c.active = false;
        c.activeClass = '';
        _.find(this.selectedCountries, (s, j) => {
          if (c.Id === s.Id) {
            const index = j + 1;
            c.active = true;
            c.chartClass = `bullet-${index}`;
          }
        });
      });

      if (this.$route.params.view === 'portrait') {
        _.find(this.countries, (c, j) => {
          if (c.active) {
            c.activeClass = `bullet-${2}`;
          }
        });
      }

      return this.countries;
    },
    toggleList() {
      this.isActive = !this.isActive;
    },
  },
  props: {
    countries: null,
    selectedCountries: null,
    colors: null,
  },
  updated() {
    this.$nextTick(() => {
      setTimeout(() => {
        const IF = parent.document.getElementById('idIframe');
        if (IF) {
          const height = (document.body.scrollHeight) ? document.body.scrollHeight : 600;
          IF.height = height + 20;
        }
      }, 400);
    });
  },
};
</script>

<style scoped lang="scss">
.country-select {

  border-top: 1px solid $color-grey-dark;
  border-bottom: 1px solid $color-grey-dark;
  margin: 0 0 20px;

  .country-list-view {
    padding: $padding-min $padding-default;

    h3 {
      position: relative;
      text-align: left;
      font-size: 12px;
      // margin: 0 0 $padding-default 0;
      margin: 0;

      a {
        display: block;
        padding-left: $padding-default;
        color: $color-brand;

        img {
          position: absolute;
          top: 50%;
          left: 0;
          width: 15px;
          height: 15px;
          @extend .animateAll;
          transform: translateY(-50%) rotate(90deg);
        }

        &.active img {
          transform: translateY(-50%) rotate(180deg);
        }

      }
    }
    .country-list {
      position: relative;
      width: 100%;
      margin: 0 auto;
      columns: 3;
      margin: $padding-default 0 0 0;
      @extend .animateAll;

      &.active {
        margin-top:0;
      }

      a {
        display: block;
        text-align: right;
        color: $color-black;
        padding: $padding-min/2;

        &.active {
          color: $color-brand;
          text-decoration: underline;
        }
      }
    }
  }

  @include bp(s) {
    border: none;
  }
}
</style>
